import React from 'react';

import { ConfirmModal } from '~/components/ConfirmModal';

interface SetDefaultProfileConfirmModalProps {
  profileName: string;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SetDefaultProfileConfirmModal: React.FC<SetDefaultProfileConfirmModalProps> = ({
  profileName,
  isOpen,
  isSubmitting,
  onClose,
  onConfirm,
}) => (
  <ConfirmModal
    isOpen={isOpen}
    isSubmitting={isSubmitting}
    onClose={onClose}
    onPrimaryBtnClick={onConfirm}
    title="Set as default profile"
    contentText={`All adjusters without an explicit profile will use ${profileName}. Continue?`}
    primaryButtonName="Set as default"
    secondaryButtonName="Cancel"
  />
);

export default SetDefaultProfileConfirmModal;
